import RestrictedWordsPage from "../../../components/settings/restricted/RestrictedWordsPage"

export default RestrictedWordsPage
